// extracted by mini-css-extract-plugin
export default {"users-block":"UsersInfoBlock_users-block__T6ab9","users-block__inner":"UsersInfoBlock_users-block__inner__JOeL2"};